export default {
  en: {
    heading: 'Ready-made topics',
    filterRoleplay: 'Roleplay',
    filterIdiom: 'Idioms',
    showMore: 'Show more',
  },
  ru: {
    heading: 'Готовые темы',
    filterRoleplay: 'Ролевые игры',
    filterIdiom: 'Идиомы',
    showMore: 'Показать ещё',
  },
  de: {
    heading: 'Fertige Themen',
    filterRoleplay: 'Rollenspiele',
    filterIdiom: 'Idiome',
    showMore: 'Mehr anzeigen',
  },
  pt: {
    heading: 'Tópicos prontos',
    filterRoleplay: 'Jogos de papéis',
    filterIdiom: 'Expressões',
    showMore: 'Mostrar mais',
  },
  fr: {
    heading: 'Sujets prêts à l’emploi',
    filterRoleplay: 'Jeux de rôle',
    filterIdiom: 'Expressions',
    showMore: 'Afficher plus',
  },
  es: {
    heading: 'Temas listos',
    filterRoleplay: 'Juegos de rol',
    filterIdiom: 'Modismos',
    showMore: 'Mostrar más',
  },
};
